export const POSTS_FAIL = 'POSTS_FAIL'
export const POSTS_SUCCESS = 'POSTS_SUCCESS'
export const POSTS_LOADING = 'POSTS_LOADING'

export const CREATE_POST_FAIL = 'CREATE_POST_FAIL'
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS'
export const CREATE_POST_LOADING = 'CREATE_POST_LOADING'

export const DELETE_POST_FAIL = 'DELETE_POST_FAIL'
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS'
export const DELETE_POST_LOADING = 'DELETE_POST_LOADING'

export const POST_LIKE = 'POST_LIKE'
export const POST_LIKE_REMOVE = 'POST_LIKE_REMOVE'
export const POST_DISLIKE = 'POST_DISLIKE'
export const POST_DISLIKE_REMOVE = 'POST_DISLIKE_REMOVE'

export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_LOADING = 'CREATE_COMMENT_LOADING'

export const COMMENTS_FAIL = 'COMMENTS_FAIL'
export const COMMENTS_SUCCESS = 'COMMENTS_SUCCESS'
export const COMMENTS_LOADING = 'COMMENTS_LOADING'

export const DELETE_COMMENT_FAIL = 'DELETE_COMMENT_FAIL'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_LOADING = 'DELETE_COMMENT_LOADING'
